import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Common from '../utilities/common';
import $ from "jquery";
import ProvinciaNew from './ProvinciaNew';
import { Provincia } from './Provincia';
import { DataGrid, GridRowSelectionModel, GridRowId, GridToolbar, GridCsvExportOptions, GridToolbarContainer, useGridApiContext, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import ProvinciaDelete from './ProvinciaDelete';
import ProvinciaEdit from './ProvinciaEdit';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import provincias from '../provincias.png';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import EntityPermissions from '../components/EntityPermissions';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntitySettings from '../components/EntitySettings';
import EditIcon from '@mui/icons-material/Edit';
import FeatureManager from '../components/Utilities/FeatureManager';

export interface IProvinciasState {
    data: Provincia[];
    loading: boolean;
    selectedSex: string;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedProvincia: GridRowId[];
    progress: number;
    checkBoxSelection: boolean;
    rowSelected: null | HTMLElement;
    openRowMenu: boolean;
}

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'provincias' })}
        >
            Exportar CSV
        </Button>
    );
}

export default class ProvinciasView extends React.Component<{}, IProvinciasState> {
    _file: any;
    _fileContent: any[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedProvincia: [],
            checkBoxSelection: false,
            rowSelected: null,
            openRowMenu: false,
            progress: 0
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Provincias} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Provincias',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <HolidayVillageOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Provincias
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Provincias}/>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length > 0 && (
                                    <DataGrid
                                        autoHeight
                                        loading={this.state.data.length == 0}
                                        slots={{ toolbar: this.CustomToolbar.bind(this) }}
                                        hideFooter={this.state.data.length <= 30}
                                        rows={this.state.data}
                                        columns={this.GetColumns()}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 }
                                            },
                                        }}
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={this.state.checkBoxSelection}
                                        onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                            this.setState({
                                                selectedProvincia: row,
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openDeleteForm: false,
                                                openEditForm: false
                                            });
                                        }}
                                    />
                                )
                            }
                        </Box>
                        <ProvinciaNew open={this.state.openNewForm} onSave={this.Get.bind(this)} />
                        <ProvinciaDelete open={this.state.openDeleteForm} id={this.state.selectedProvincia as number[]} onDelete={this.Get.bind(this)} />
                        <ProvinciaEdit open={this.state.openEditForm} onSave={this.Get.bind(this)} selectedItem={this.GetSelectedProvincia()}/>
                        <Menu
                            anchorEl={this.state.rowSelected}
                            open={this.state.openRowMenu}
                            onClose={() => {
                                this.setState(
                                    {
                                        rowSelected: null,
                                        openRowMenu: false
                                    }
                                );
                            }}
                        >
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <EditIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Modificar</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Eliminar</ListItemText>
                            </MenuItem>
                        </Menu>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private GetSelectedProvincia(): Provincia | undefined {
        return this.state.data.find((value: Provincia) => {
            return value.id == this.state.selectedProvincia[0] as number;
        });
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/Provincias`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedProvincia: [],
                    loading: false,
                    progress: 0
                }
            );
        })
    }

    private UploadFile(): void {
        let url = `${Common.END_POINT}/excel/upload/withcolumnnames`;

        const data = new FormData();
        data.append('file', this._file);
        $.ajax((
            {
                url: url,
                type: "POST",
                data: data,
                processData: false,
                contentType: false,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    openImportProgress: true
                }
            );

            this._fileContent = response;
            this.Import(0);
        })
    }
    
    private Import(index: number): void {
        if(index >= this._fileContent.length) {
            this.Get();
            return;
        }

        let url = `${Common.END_POINT}/masters/Provincias`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._fileContent[index]),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            const newIndex = index + 1;
            this.setState(
                {
                    progress: Math.round((newIndex / this._fileContent.length) * 100)
                }
            );

            this.Import(newIndex);
        });
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <FeatureManager entidad={Entity.Provincias} operacion='Crear'>
                    <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Crear}>
                        <Button startIcon={<AddOutlinedIcon />} variant="contained" onClick={() => {
                            this.setState(
                                {
                                    openNewForm: true,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}>
                            Nuevo
                        </Button>
                    </SecurityTrimmer>
                </FeatureManager>
                {
                    this.state.selectedProvincia.length == 1 && (
                        <FeatureManager entidad={Entity.Provincias} operacion='Editar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Editar}>
                                <Button startIcon={<EditOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false
                                        }
                                    );
                                }}>
                                    Modificar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    this.state.selectedProvincia.length > 0 && (
                        <FeatureManager entidad={Entity.Provincias} operacion='Eliminar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Eliminar}>
                                <Button startIcon={<DeleteOutlineOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true
                                        }
                                    );
                                }}>
                                    Eliminar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    ExportButton()
                }
                <Stack direction={'row'} style={{marginLeft: 'auto'}} justifyContent={'space-between'}>
                    <FormControlLabel control={<Switch defaultChecked={this.state.checkBoxSelection} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState(
                            {
                                checkBoxSelection: event.target.checked,
                                openNewForm: false,
                                openImportProgress: false,
                                openEditForm: false,
                                openDeleteForm: false
                            }
                        );
                    }}/>} label={<Typography variant='body2' color={'text.secondary'}>Selección múltiple</Typography>} />
                </Stack>
            </Stack>
        )
    }

    private RenderIconStatus(row: any, key: string): JSX.Element {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Editar}>
                <Button variant='text' style={{color: '#333'}} onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    this.setState(
                        {
                            rowSelected: event.currentTarget,
                            openRowMenu: true
                        }
                    );
                }}>
                    {
                        row[key]
                    }
                </Button>
            </SecurityTrimmer>
        )
    }

    private RenderCellExpand(params: GridRenderCellParams<any, string>) {
        console.log(params);
        return (
            <React.Fragment>
                {
                    params.field == 'id' && (
                        Common.RenderCellMenuButton(params.value!, (event: React.MouseEvent<HTMLButtonElement>) => {
                            this.setState(
                                {
                                    rowSelected: event.currentTarget,
                                    openRowMenu: true
                                }
                            );
                        })
                    )
                }
                {
                    params.field == 'creadoPor' && (
                        Common.RenderUser(params.row, 'creadoPor')
                    )
                }
                {
                    params.field == 'modificadoPor' && (
                        Common.RenderUser(params.row, 'modificadoPor')
                    )
                }
                {
                    params.field == 'creado' && (
                        Common.RenderDate2(params.value!)
                    )
                }
                {
                    params.field == 'modificado' && (
                        Common.RenderDate2(params.value!)
                    )
                }
                {
                    params.field != 'id' && params.field != 'creadoPor' && params.field != 'creado' && params.field != 'modificado' && params.field != 'modificadoPor' && (
                        params.value
                    )
                }
            </React.Fragment>
        );
    }

    public GetColumns(): GridColDef[] {
        const firstRow = this.state.data[0];
        const columns: GridColDef[] = [];
        const keys = Object.getOwnPropertyNames(firstRow);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if(key != 'creadoPorAvatar' && key != 'modificadoPorAvatar' && key != 'creadoPorAvatarColor' && key != 'modificadoPorAvatarColor') {
                let column: GridColDef = {} as GridColDef;
                column.field = key;
                column.headerName = Common.GetDataFieldDisplayName(key);
                column.width = key == 'id' ? 100 : 200;
                column.renderCell = this.RenderCellExpand.bind(this);

                if(i == keys.length - 1) {
                    column.flex = 1;
                }

                columns.push(column);
            }
        }

        return columns;
    }
}